import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const fillCredential = (email, password, accountType) => {
    setFormData({
      email: email,
      password: password
    });
    toast.success(`${accountType} credentials filled!`);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.login(formData);
      const userData = response.data;
      
      login(userData);
      toast.success(`Welcome back, ${userData.firstName}!`);
      
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.message || 'Login failed';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Login</h2>
        
        <div className="test-accounts">
          <p><strong>Test Accounts:</strong></p>
          
          <div className="test-account">
            <span className="account-label">Admin:</span>
            <div className="credential-display">
              <span className="credential">admin@automotive.com</span>
              <span className="separator">/</span>
              <span className="credential">admin123</span>
            </div>
            <button 
              type="button"
              className="autofill-btn"
              onClick={() => fillCredential('admin@automotive.com', 'admin123', 'Admin')}
              title="Auto-fill admin credentials"
            >
              ✨ Fill
            </button>
          </div>
          
          <div className="test-account">
            <span className="account-label">User:</span>
            <div className="credential-display">
              <span className="credential">user@automotive.com</span>
              <span className="separator">/</span>
              <span className="credential">user123</span>
            </div>
            <button 
              type="button"
              className="autofill-btn"
              onClick={() => fillCredential('user@automotive.com', 'user123', 'User')}
              title="Auto-fill user credentials"
            >
              ✨ Fill
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>Don't have an account? <Link to="/register">Register here</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login; 